import { render, staticRenderFns } from "./cont3.vue?vue&type=template&id=d2998832&scoped=true"
var script = {}
import style0 from "./cont3.vue?vue&type=style&index=0&id=d2998832&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2998832",
  null
  
)

export default component.exports